module.exports = __webpack_public_path__ + "static/media/procore.24877d4f.png";